var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
import moment from 'moment';
import { downloadFile } from '@/shared/utils/helpers';
let Calendar = class Calendar extends Vue {
    constructor() {
        super(...arguments);
        this.selectedDate = moment().format('YYYY/MM/DD');
        this.selectedTime = moment().format('HH:mm');
        this.description = '';
    }
    get companyName() {
        return ((this.company && (this.company.fantasyName || this.company.name)) || '');
    }
    createInvite() {
        const start = moment(`${this.selectedDate} ${this.selectedTime}`, 'YYYY/MM/DD HH:mm').format('YYYYMMDDTHHmmss');
        const end = moment(`${this.selectedDate} ${this.selectedTime}`, 'YYYY/MM/DD HH:mm')
            .add(1, 'hour')
            .format('YYYYMMDDTHHmmss');
        const icsContent = [
            'BEGIN:VCALENDAR',
            'VERSION:2.0',
            'PRODID:-//Speedio//Atlas//PT',
            'BEGIN:VEVENT',
            `DTSTART:${start}`,
            `DTEND:${end}`,
            `SUMMARY:Reunião com ${this.companyName}`,
            `DESCRIPTION:${this.description.replace(/\n/g, '\\n')}`,
            'END:VEVENT',
            'END:VCALENDAR',
        ].join('\n');
        downloadFile(icsContent, `${this.companyName}.ics`);
    }
};
__decorate([
    Prop({ default: () => ({}) })
], Calendar.prototype, "company", void 0);
Calendar = __decorate([
    Component({
        name: 'Calendar',
    })
], Calendar);
export default Calendar;
